import { SET_REMINDER_SCHEDULES } from "../actions/actionsType";

const INITIAL_STATE = {
  reminderSchedules: [],
  timeZones: [],
  timeZonesParsed: {},
  timeZonesByUtcId: {},
};

export const reminderSchedulesReducer = (state = INITIAL_STATE, action) => {
  const { payload } = action;
  if (action.type === SET_REMINDER_SCHEDULES) {
    return {
      ...state,
      reminderSchedules: payload,
    };
  }

  return state;
};
